import { Scrollspy } from '@makotot/ghostui';
import AppTabContainer from '../../common/tabs/AppTabContainer';
import classes from './booking-link.module.scss';
import AppTab from '../../common/tabs/AppTab';
import { useRef, useState } from 'react';
import classNames from 'classnames';
import { debounce } from 'lodash';

let tabTimeout = null;

function TreatmentCategoryTabs({ sectionRefs, tabList, scrollCategory }) {
    const [activeTabIndex, setActiveTabIndex] = useState(null);

    const scrollRef = useRef(null);
    let isDragging = false;
    let startX = 0;
    let scrollLeft = 0;

    const handleMouseDown = (e) => {
        isDragging = true;
        startX = e.pageX - (scrollRef.current?.offsetLeft || 0);
        scrollLeft = scrollRef.current?.scrollLeft || 0;
    };

    const handleMouseLeave = () => {
        isDragging = false;
    };

    const handleMouseUp = () => {
        isDragging = false;
    };

    const handleMouseMove = (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.pageX - (scrollRef.current?.offsetLeft || 0);
        const walk = x - startX;
        if (scrollRef.current) {
            scrollRef.current.scrollLeft = scrollLeft - walk;
        }
    };

    const handleChangeCategory = (item, index) => {
        if(tabTimeout) {
            clearTimeout(tabTimeout);
        }
        setActiveTabIndex(index);

        let categoryItem = document.getElementById(item.category_id.toString());
        if (categoryItem) {
            scrollCategory(categoryItem.offsetTop);
            tabTimeout = setTimeout(() => {
                setActiveTabIndex(null);
            }, 1000);
        }
    };

    const handleAutoScrollMobile = debounce((index) => {
        document.querySelector(`[data-category-tab-id="category-tab-${index}"]`)?.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest', // Prevents vertical scroll
            inline: 'center', // Ensures horizontal centering
        });
    }, 300);
    return (
        <AppTabContainer
            ref={scrollRef}
            onMouseDown={handleMouseDown}
            onMouseLeave={handleMouseLeave}
            onMouseUp={handleMouseUp}
            onMouseMove={handleMouseMove}
            className={classes.categoryTabsMobile}
        >
            {tabList?.length > 0 && (
                <Scrollspy sectionRefs={sectionRefs} rootSelector="#my-list-root">
                    {({ currentElementIndexInViewport }) => (
                        <>
                            {handleAutoScrollMobile(currentElementIndexInViewport)}
                            {tabList?.map((item, index) => {
                                return (
                                    <AppTab
                                        shallTruncate
                                        isActive={
                                            activeTabIndex === index ||
                                            (currentElementIndexInViewport === index &&
                                                activeTabIndex === null)
                                        }
                                        data-category-tab-id={`category-tab-${index}`}
                                        className={classNames(
                                            classes.categoryTab,
                                            classes.categoryTabMobile
                                        )}
                                        key={item?.category_id}
                                        onClick={() => {
                                            handleChangeCategory(item, index);
                                        }}
                                        // title={item?.category_name}
                                    >
                                        {item?.category_name}
                                    </AppTab>
                                );
                            })}
                        </>
                    )}
                </Scrollspy>
            )}
        </AppTabContainer>
    );
}
export default TreatmentCategoryTabs;
